import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { appTypes } from '../../../common/constants';
import { config } from '../config';
import { AuthenticatedHttpBackend } from './AuthenticatedHttpBackend';
import { convertLanguageJsonToObject } from './resources';
import types from './types.json';

convertLanguageJsonToObject(types);

let isInitialized = false;

export const initializeI18n = async () => {
  if (isInitialized || config.appType !== appTypes.benefit) return;

  await i18n
    .use(initReactI18next)
    .use(AuthenticatedHttpBackend)
    .init({
      lng: config.defaultLanguage,
      fallbackLng: false,
      debug: false,
      backend: {
        loadPath: `${config.benefitApiUrl}/static/resources`,
        crossDomain: true,
      },
      interpolation: {
        escapeValue: false,
      },
    });

  isInitialized = true;
};

export default i18n;
